enum WalletType {
  COINBASE = 'cb-wallet',
  METAMASK = 'metamask',
}

export default WalletType;
